import { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import MarketRestrictedModal from "./MarketRestrictedModal";
import { checkMarketRestriction } from "@/services/commonServices";
import { getLocalStorage } from "@/helpers/common";
import {
  LOGIN_MARKET_NOTICE_EVENT,
  LOGIN_MARKET_NOTICE_KEY,
  parseUserLocation,
} from "@/helpers/marketRestriction";
import { USER_INFO_KEY, USER_TYPE_AGENT } from "@/constants/common";

// GTCH-853. Shows MarketRestrictedModal once per sign-in to agents whose
// profile location is in a creation-gated market. The API exempts BLS tenants.
const LoginMarketNotice = () => {
  const [show, setShow] = useState(false);

  const checkPendingNotice = useCallback(async () => {
    if (!localStorage.getItem(LOGIN_MARKET_NOTICE_KEY)) return;

    const userInfo = getLocalStorage(USER_INFO_KEY)?.userInfo;
    if (!userInfo?.userId || Number(userInfo.userType) !== USER_TYPE_AGENT) {
      localStorage.removeItem(LOGIN_MARKET_NOTICE_KEY);
      return;
    }

    // A fresh signup has no location until the profile is completed; keep the
    // flag so the notice still shows once it is.
    const location = parseUserLocation(userInfo.location);
    if (!location) return;

    // Claimed before the request so a second mounted instance cannot show it too.
    localStorage.removeItem(LOGIN_MARKET_NOTICE_KEY);
    try {
      const response = await checkMarketRestriction(location);
      if (_.get(response, "result.isCreationRestricted", false)) setShow(true);
    } catch (e) {
      console.log("login market notice check failed", e);
    }
  }, []);

  useEffect(() => {
    checkPendingNotice();
    window.addEventListener(LOGIN_MARKET_NOTICE_EVENT, checkPendingNotice);
    return () =>
      window.removeEventListener(LOGIN_MARKET_NOTICE_EVENT, checkPendingNotice);
  }, [checkPendingNotice]);

  return <MarketRestrictedModal show={show} onHide={() => setShow(false)} />;
};

export default LoginMarketNotice;
